import manifest from './manifest';
import Entry from './pages/Entry';
import FAQ from './pages/FAQ';
import TermsAndConditions from './pages/TermsAndConditions';
import EveryBodyWins from './pages/EveryBodyWins';
import Profile from './pages/Profile';
import Cart from './pages/Cart';

const magicTemplate = { manifest, pages: { Entry, FAQ, TermsAndConditions, EveryBodyWins, Profile, Cart } };

export default magicTemplate;
